export const CARD_FORM_ADD_MEDIA_LABEL = 'Ajouter une image';
export const CARD_ENHANCEMENT_MAIN_TITLE = "Enrichir l'encart";
export const CARD_FORM_BODY_PLACEHOLDER = 'Saisissez le contenu de votre card';
export const CARD_FORM_DESCRIPTION_LABEL = 'Description';
export const CARD_FORM_LOCATION_LABEL = 'Emplacement';
export const CARD_FORM_SECONDARY_TITLE_LABEL = 'Titre secondaire';
export const CARD_FORM_TITLE_LABEL = 'Titre';
export const CARD_FORM_URL_LABEL = 'Url';
